import script from "./IPromo.vue?vue&type=script&setup=true&lang=js"
export * from "./IPromo.vue?vue&type=script&setup=true&lang=js"

import "./IPromo.vue?vue&type=style&index=0&id=95d890c6&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95d890c6"]])

export default __exports__